import type { ExposedMenu } from '@moniebook-web/components/widgets/sidebar';

export const onboardingMenu: ExposedMenu = {
    menuGroups: [],
    submenu: [],
    modules: [],
    subModules: [],
};
